import { render, staticRenderFns } from "./SubscriptionsStatistics.vue?vue&type=template&id=054a77d6"
import script from "./SubscriptionsStatistics.vue?vue&type=script&lang=js"
export * from "./SubscriptionsStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports